// editable Dataview
webix.protoUI({
	name:"fileview"
}, webix.EditAbility, webix.ui.dataview);